module.exports = __webpack_public_path__ + "img/envelope-dot.efc6b3dd.svg";